module.exports = __webpack_public_path__ + "img/prop-trade-header-bg3.d5541e49.png";